import { useNavigate } from 'react-router-dom';
import ProfileGoBackButton from '../ProfileGoBackButton/ProfileGoBackButton';
import './ProfileNotifications.css';
import { PROFILE_MAIN_LINK } from '../../../assets/utils/constants';
import { useEffect, useState } from 'react';
import mainAppApi from '../../../assets/api/MainAppApi';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';

function ProfileNotifications() {
    const navigate = useNavigate()
    const [notifications, setNotifications] = useState(null)
    const [preloaders, setPreloaders] = useState({
        init: true,
    })

    useEffect(() => {
        mainAppApi.getAllNotifications()
            .then((res) => {
                console.log(res)
                setNotifications(res.data)
                setPreloaders(prevValue => ({
                    ...prevValue,
                    init: false
                }))
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])


    return (
        <div className='profile-notifications'>
            <div className='profile-notifications__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}`)
                    }}
                />
                <div className='profile-notifications__heading-title-box' >
                    <p className='profile-notifications__heading-title'>Notifications</p>
                </div>
            </div>
            {preloaders.init ?
                <div className='profile-notifications__preloader'>
                    <MiniPreloader />
                </div>
                :
                <div className='profile-notifications__items'>
                    {notifications && notifications.length > 0 ?
                        notifications.map((notification) => (
                            <div className='profile-notifications__item'>
                                <img className='profile-notifications__item-img' src={notification.image.urls.orig} alt='' />
                                <p className='profile-notifications__item-message'>{notification.message}</p>
                            </div>
                        ))
                        :
                        <p className='profile-notifications__no-item'>No Notifications Yet</p>}

                </div>
            }

        </div>
    );
}

export default ProfileNotifications